export default "__VITE_ASSET__DvdG2Fbg__"